<script setup lang="ts">
import { storeToRefs } from 'pinia'

import ProfileAbout from '~/components/influencer/profile/About.vue'
import Suggestion from '~/components/influencer/profile/about/Suggestion.vue'
import ProfileHeader from '~/components/influencer/profile/Header.vue'
import ProfileInteractions from '~/components/influencer/profile/Interactions.vue'
import InfluencerProfileSpotifyPlaylistDisplayCollection from '~/components/influencer/profile/SpotifyPlaylistDisplayCollection.vue'
// import ForceCurator from '~/components/shared/profile/ForceCurator.vue'
import TransitionDirectionalSwipe from '~/components/transitions/directionalSwipe.vue'

import { useIntercomMove } from '~/composables/useIntercomMove'

import { useUserStore } from '~/stores/user'
import { useUserInfluencerStore } from '~/stores/userInfluencer'

import type { Influencer } from '~/types/influencer'
import type InfluencerInteractions from '~/types/influencerInteraction'

type Props = {
  influencer: Influencer
  interactions: InfluencerInteractions[]
  suggested: Influencer['id'][]
}

const props = defineProps<Props>()

const { id: INF_ID } = storeToRefs(useUserInfluencerStore())
const { IS_INF, IS_BAND } = storeToRefs(useUserStore())

useIntercomMove((SET_INTERCOM_HIGHER) => {
  if (IS_BAND.value) SET_INTERCOM_HIGHER()
})

const showAbout = ref(true)
const showInteraction = ref(false)

const userIsOwner = computed<boolean>(
  () => IS_INF.value && INF_ID.value === props.influencer.id,
)

const hasInteraction = computed<boolean>(
  () => props.interactions?.length > 0 && IS_BAND.value,
)

function toggle(): void {
  showAbout.value = !showAbout.value
  showInteraction.value = !showInteraction.value
}
</script>

<template>
  <div
    id="ignoreFontUpscale"
    class="influencerProfileMainWrapper ignoreFontUpscale tw-relative tw-mb-32 tw-w-full"
  >
    <!-- N.B: component hidden for Curators for now -->
    <!-- <div class="mainParentContainer">
      <ForceCurator v-if="userIsOwner" :influencer="influencer" />
    </div> -->
    <ProfileHeader
      :influencer="influencer"
      :user-is-owner="userIsOwner"
      :has-interaction="hasInteraction"
      :show-about="showAbout"
      :show-interaction="showInteraction"
      @toggle="toggle"
    />
    <TransitionDirectionalSwipe
      :direction="showAbout ? 'left' : 'right'"
      mode="out-in"
    >
      <KeepAlive>
        <ProfileAbout v-if="showAbout" :influencer="influencer">
          <template #post-content>
            <div
              v-if="
                influencer.spotify_playlists.length &&
                influencer.media_links.spotify.length > 0
              "
              class="tw-mt-6"
            >
              <InfluencerProfileSpotifyPlaylistDisplayCollection
                :spotify-playlists="influencer.spotify_playlists"
              />
            </div>
          </template>
        </ProfileAbout>
        <ProfileInteractions
          v-else-if="showInteraction && hasInteraction"
          :influencer="influencer"
          :interactions="interactions"
        />
      </KeepAlive>
    </TransitionDirectionalSwipe>
    <div class="mainParentContainer">
      <Suggestion
        v-if="!userIsOwner"
        :influencer="influencer"
        :suggested="suggested"
      />
    </div>
  </div>
</template>
